import { useCallback } from 'react';
import { useItemsStore } from '../store';
import { Category, Product } from '../interfaces/domain/menu';
import { findProductById, findCategoryByProductId } from '../utils/findInMenu';

export const useFindInMenu = () => {
  const categories = useItemsStore((s) => s.menuData.categories);

  const findProduct = useCallback(
    (id: string): Product | null => findProductById(categories, id),
    [categories]
  );

  const findCategory = useCallback(
    (productId: string): Pick<Category, 'name' | 'description'> | null =>
      findCategoryByProductId(categories, productId),
    [categories]
  );

  return { findProduct, findCategory };
};
